/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './prepare-order-items.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../../$$_gendir/node_modules/@angular/material/typings/index.ngfactory';
import * as i3 from '@angular/material';
import * as i4 from '@angular/forms';
import * as i5 from '@angular/flex-layout/flexbox/api/class';
import * as i6 from '@angular/flex-layout/media-query/media-monitor';
import * as i7 from '@angular/common';
import * as i8 from '@angular/flex-layout/flexbox/api/layout';
import * as i9 from '@angular/flex-layout/flexbox/api/layout-gap';
import * as i10 from '../../../../../../app/shared/pipes/translate.pipe';
import * as i11 from '@angular/flex-layout/flexbox/api/flex';
import * as i12 from '@angular/flex-layout/flexbox/api/layout-wrap';
import * as i13 from '@angular/router';
import * as i14 from '../../../../../../app/agatextscreens/pda/shipping/prepare-order-items/prepare-order-items.component';
import * as i15 from '@angular/flex-layout/flexbox/api/flex-align';
import * as i16 from '../../../../../../app/shared/services/pallet.service';
import * as i17 from '@angular/http';
import * as i18 from '../../../../../../app/app.constants';
import * as i19 from '../../../../../../app/shared/services/authentication.service';
import * as i20 from '../../../../../../app/agatextscreens/purchasing/products/product.service';
import * as i21 from '../../../../../../app/shared/services/printing.service';
import * as i22 from '../../../../../../app/agatextscreens/sales/sales.service';
import * as i23 from '../../../../../../app/agatextscreens/purchasing/pos/po.service';
import * as i24 from '@covalent/core/dialogs/services/dialog.service';
import * as i25 from '../../../../../../app/agatextscreens/inventory/inventory.service';
const styles_PrepareOrderItemsComponent:any[] = [i0.styles];
export const RenderType_PrepareOrderItemsComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_PrepareOrderItemsComponent,data:{}});
function View_PrepareOrderItemsComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),17,'md-input-container',
      ([] as any[]),[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_MdInputContainer_0,i2.RenderType_MdInputContainer)),i1.ɵdid(7389184,
      (null as any),6,i3.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,[2,i4.NgForm],
          [2,i4.FormGroupDirective]],(null as any),(null as any)),i1.ɵqud(335544320,
      7,{_mdInputChild:0}),i1.ɵqud(335544320,8,{_placeholderChild:0}),i1.ɵqud(603979776,
      9,{_errorChildren:1}),i1.ɵqud(603979776,10,{_hintChildren:1}),i1.ɵqud(603979776,
      11,{_prefixChildren:1}),i1.ɵqud(603979776,12,{_suffixChildren:1}),(_l()(),i1.ɵted(1,
      ['\n            '])),(_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput',
      '']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
      (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,
      'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
      (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
      0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
      'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
      'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('input' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,10)._handleInput($event.target.value)) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,10).onTouched()) !== false);
      ad = (pd_1 && ad);
    }
    if (('compositionstart' === en)) {
      const pd_2:any = ((<any>i1.ɵnov(_v,10)._compositionStart()) !== false);
      ad = (pd_2 && ad);
    }
    if (('compositionend' === en)) {
      const pd_3:any = ((<any>i1.ɵnov(_v,10)._compositionEnd($event.target.value)) !== false);
      ad = (pd_3 && ad);
    }
    if (('blur' === en)) {
      const pd_4:any = ((<any>i1.ɵnov(_v,15)._onBlur()) !== false);
      ad = (pd_4 && ad);
    }
    if (('focus' === en)) {
      const pd_5:any = ((<any>i1.ɵnov(_v,15)._onFocus()) !== false);
      ad = (pd_5 && ad);
    }
    if (('input' === en)) {
      const pd_6:any = ((<any>i1.ɵnov(_v,15)._onInput()) !== false);
      ad = (pd_6 && ad);
    }
    if (('ngModelChange' === en)) {
      const pd_7:any = ((<any>(_co._scanned = $event)) !== false);
      ad = (pd_7 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i4.DefaultValueAccessor,
      [i1.Renderer2,i1.ElementRef,[2,i4.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),
      i1.ɵprd(1024,(null as any),i4.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i4.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i4.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i4.NgControl,
          (null as any),[i4.NgModel]),i1.ɵdid(16384,(null as any),0,i4.NgControlStatus,
          [i4.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[7,4]],0,i3.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i4.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n          ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_24:any = _co._scanned;
    _ck(_v,12,0,currVal_24);
    const currVal_25:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,15,0,_ck(_v,16,0,
        i1.ɵnov((<any>_v.parent),0),'scan',_co._authService.getLanguage())),'');
    _ck(_v,15,0,currVal_25);
  },(_ck,_v) => {
    const currVal_0:any = (null as any);
    const currVal_1:any = true;
    const currVal_2:any = i1.ɵnov(_v,1)._isErrorState();
    const currVal_3:any = i1.ɵnov(_v,1)._mdInputChild.focused;
    const currVal_4:any = i1.ɵnov(_v,1)._shouldForward('untouched');
    const currVal_5:any = i1.ɵnov(_v,1)._shouldForward('touched');
    const currVal_6:any = i1.ɵnov(_v,1)._shouldForward('pristine');
    const currVal_7:any = i1.ɵnov(_v,1)._shouldForward('dirty');
    const currVal_8:any = i1.ɵnov(_v,1)._shouldForward('valid');
    const currVal_9:any = i1.ɵnov(_v,1)._shouldForward('invalid');
    const currVal_10:any = i1.ɵnov(_v,1)._shouldForward('pending');
    _ck(_v,0,1,[currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8,currVal_9,currVal_10]);
    const currVal_11:any = i1.ɵnov(_v,14).ngClassUntouched;
    const currVal_12:any = i1.ɵnov(_v,14).ngClassTouched;
    const currVal_13:any = i1.ɵnov(_v,14).ngClassPristine;
    const currVal_14:any = i1.ɵnov(_v,14).ngClassDirty;
    const currVal_15:any = i1.ɵnov(_v,14).ngClassValid;
    const currVal_16:any = i1.ɵnov(_v,14).ngClassInvalid;
    const currVal_17:any = i1.ɵnov(_v,14).ngClassPending;
    const currVal_18:any = true;
    const currVal_19:any = i1.ɵnov(_v,15).id;
    const currVal_20:any = i1.ɵnov(_v,15).placeholder;
    const currVal_21:any = i1.ɵnov(_v,15).disabled;
    const currVal_22:any = i1.ɵnov(_v,15).required;
    const currVal_23:any = (i1.ɵnov(_v,15).ariaDescribedby || (null as any));
    _ck(_v,9,1,[currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,
        currVal_17,currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23]);
  });
}
function View_PrepareOrderItemsComponent_2(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),17,'md-input-container',
      ([] as any[]),[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_MdInputContainer_0,i2.RenderType_MdInputContainer)),i1.ɵdid(7389184,
      (null as any),6,i3.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,[2,i4.NgForm],
          [2,i4.FormGroupDirective]],(null as any),(null as any)),i1.ɵqud(335544320,
      13,{_mdInputChild:0}),i1.ɵqud(335544320,14,{_placeholderChild:0}),i1.ɵqud(603979776,
      15,{_errorChildren:1}),i1.ɵqud(603979776,16,{_hintChildren:1}),i1.ɵqud(603979776,
      17,{_prefixChildren:1}),i1.ɵqud(603979776,18,{_suffixChildren:1}),(_l()(),i1.ɵted(1,
      ['\n            '])),(_l()(),i1.ɵeld(0,(null as any),1,7,'textarea',[['mdInput',
      ''],['rows','10']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
      [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
      [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
          (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
          0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
      'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
      'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('input' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,10)._handleInput($event.target.value)) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,10).onTouched()) !== false);
      ad = (pd_1 && ad);
    }
    if (('compositionstart' === en)) {
      const pd_2:any = ((<any>i1.ɵnov(_v,10)._compositionStart()) !== false);
      ad = (pd_2 && ad);
    }
    if (('compositionend' === en)) {
      const pd_3:any = ((<any>i1.ɵnov(_v,10)._compositionEnd($event.target.value)) !== false);
      ad = (pd_3 && ad);
    }
    if (('blur' === en)) {
      const pd_4:any = ((<any>i1.ɵnov(_v,15)._onBlur()) !== false);
      ad = (pd_4 && ad);
    }
    if (('focus' === en)) {
      const pd_5:any = ((<any>i1.ɵnov(_v,15)._onFocus()) !== false);
      ad = (pd_5 && ad);
    }
    if (('input' === en)) {
      const pd_6:any = ((<any>i1.ɵnov(_v,15)._onInput()) !== false);
      ad = (pd_6 && ad);
    }
    if (('ngModelChange' === en)) {
      const pd_7:any = ((<any>(_co._scanned = $event)) !== false);
      ad = (pd_7 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i4.DefaultValueAccessor,
      [i1.Renderer2,i1.ElementRef,[2,i4.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),
      i1.ɵprd(1024,(null as any),i4.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i4.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i4.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i4.NgControl,
          (null as any),[i4.NgModel]),i1.ɵdid(16384,(null as any),0,i4.NgControlStatus,
          [i4.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[13,4]],0,i3.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i4.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n          ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_24:any = _co._scanned;
    _ck(_v,12,0,currVal_24);
    const currVal_25:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,15,0,_ck(_v,16,0,
        i1.ɵnov((<any>_v.parent),0),'scan',_co._authService.getLanguage())),'');
    _ck(_v,15,0,currVal_25);
  },(_ck,_v) => {
    const currVal_0:any = (null as any);
    const currVal_1:any = true;
    const currVal_2:any = i1.ɵnov(_v,1)._isErrorState();
    const currVal_3:any = i1.ɵnov(_v,1)._mdInputChild.focused;
    const currVal_4:any = i1.ɵnov(_v,1)._shouldForward('untouched');
    const currVal_5:any = i1.ɵnov(_v,1)._shouldForward('touched');
    const currVal_6:any = i1.ɵnov(_v,1)._shouldForward('pristine');
    const currVal_7:any = i1.ɵnov(_v,1)._shouldForward('dirty');
    const currVal_8:any = i1.ɵnov(_v,1)._shouldForward('valid');
    const currVal_9:any = i1.ɵnov(_v,1)._shouldForward('invalid');
    const currVal_10:any = i1.ɵnov(_v,1)._shouldForward('pending');
    _ck(_v,0,1,[currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8,currVal_9,currVal_10]);
    const currVal_11:any = i1.ɵnov(_v,14).ngClassUntouched;
    const currVal_12:any = i1.ɵnov(_v,14).ngClassTouched;
    const currVal_13:any = i1.ɵnov(_v,14).ngClassPristine;
    const currVal_14:any = i1.ɵnov(_v,14).ngClassDirty;
    const currVal_15:any = i1.ɵnov(_v,14).ngClassValid;
    const currVal_16:any = i1.ɵnov(_v,14).ngClassInvalid;
    const currVal_17:any = i1.ɵnov(_v,14).ngClassPending;
    const currVal_18:any = true;
    const currVal_19:any = i1.ɵnov(_v,15).id;
    const currVal_20:any = i1.ɵnov(_v,15).placeholder;
    const currVal_21:any = i1.ɵnov(_v,15).disabled;
    const currVal_22:any = i1.ɵnov(_v,15).required;
    const currVal_23:any = (i1.ɵnov(_v,15).ariaDescribedby || (null as any));
    _ck(_v,9,1,[currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,
        currVal_17,currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23]);
  });
}
function View_PrepareOrderItemsComponent_5(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'md-icon',[['md-list-icon',
      ''],['role','img'],['style','color: red;']],[[2,'mat-icon',(null as any)],[2,
      'mat-list-icon',(null as any)]],(null as any),(null as any),i2.View_MdIcon_0,
      i2.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,[[2,
      i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(9027584,(null as any),0,i3.MdIcon,[i1.ElementRef,i1.Renderer2,i3.MdIconRegistry],
          (null as any),(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdListIconCssMatStyler,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(0,['cancel']))],
      (_ck,_v) => {
        _ck(_v,2,0);
      },(_ck,_v) => {
        const currVal_0:any = true;
        const currVal_1:any = true;
        _ck(_v,0,0,currVal_0,currVal_1);
      });
}
function View_PrepareOrderItemsComponent_6(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'md-icon',[['md-list-icon',
      ''],['role','img']],[[2,'mat-icon',(null as any)],[2,'mat-list-icon',(null as any)]],
      (null as any),(null as any),i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(16384,
      (null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
      (null as any),(null as any)),i1.ɵdid(9027584,(null as any),0,i3.MdIcon,[i1.ElementRef,
      i1.Renderer2,i3.MdIconRegistry],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
      0,i3.MdListIconCssMatStyler,([] as any[]),(null as any),(null as any)),(_l()(),
      i1.ɵted(0,['radio_button_unchecked\n              ']))],(_ck,_v) => {
    _ck(_v,2,0);
  },(_ck,_v) => {
    const currVal_0:any = true;
    const currVal_1:any = true;
    _ck(_v,0,0,currVal_0,currVal_1);
  });
}
function View_PrepareOrderItemsComponent_7(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'md-icon',[['md-list-icon',
      ''],['role','img'],['style','color: green; cursor: pointer']],[[2,'mat-icon',
      (null as any)],[2,'mat-list-icon',(null as any)]],[[(null as any),'click']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.unPrepareItem((<any>_v.parent).context.$implicit)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(9027584,(null as any),0,i3.MdIcon,[i1.ElementRef,i1.Renderer2,i3.MdIconRegistry],
          (null as any),(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdListIconCssMatStyler,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(0,['check_circle']))],
      (_ck,_v) => {
        _ck(_v,2,0);
      },(_ck,_v) => {
        const currVal_0:any = true;
        const currVal_1:any = true;
        _ck(_v,0,0,currVal_0,currVal_1);
      });
}
function View_PrepareOrderItemsComponent_8(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'del',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit.piece_number;
    _ck(_v,1,0,currVal_0);
  });
}
function View_PrepareOrderItemsComponent_9(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['','']))],(null as any),(_ck,_v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit.piece_number;
    _ck(_v,1,0,currVal_0);
  });
}
function View_PrepareOrderItemsComponent_10(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',[['style',
      'height: 60%; color:darkgray']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['of ','m']))],(null as any),(_ck,
      _v) => {
    const currVal_0:any = (<any>_v.parent).context.$implicit.full_length;
    _ck(_v,1,0,currVal_0);
  });
}
function View_PrepareOrderItemsComponent_11(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),2,'span',[['style',
      'height: 60%; color:darkgray']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['[',': ',']'])),i1.ɵppd(2)],(null as any),
      (_ck,_v) => {
        var _co:any = _v.component;
        const currVal_0:any = i1.ɵunv(_v,1,0,_ck(_v,2,0,i1.ɵnov((<any>(<any>(<any>_v.parent).parent).parent),
            0),'pallet',_co._authService.getLanguage()));
        const currVal_1:any = (<any>_v.parent).context.$implicit.prepared_pallet_name;
        _ck(_v,1,0,currVal_0,currVal_1);
      });
}
function View_PrepareOrderItemsComponent_12(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),8,'span',[['class',
      'linkCursor'],['md-line','']],[[2,'mat-line',(null as any)]],[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.printFreeTextLabel((<any>_v.parent).context.$implicit)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(16384,[[21,4]],0,i3.MdLine,([] as any[]),
      (null as any),(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
      [i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
          i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
      ['\n                '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),3,'md-icon',
      [['role','img']],[[2,'mat-icon',(null as any)]],(null as any),(null as any),
      i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(9027584,(null as any),0,i3.MdIcon,[i1.ElementRef,i1.Renderer2,i3.MdIconRegistry],
          (null as any),(null as any)),(_l()(),i1.ɵted(0,['local_offer'])),(_l()(),
          i1.ɵted((null as any),[' ','\n              ']))],(_ck,_v) => {
    const currVal_1:any = 'linkCursor';
    _ck(_v,2,0,currVal_1);
    _ck(_v,6,0);
  },(_ck,_v) => {
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_2:any = true;
    _ck(_v,4,0,currVal_2);
    const currVal_3:any = (<any>_v.parent).context.$implicit.tag;
    _ck(_v,8,0,currVal_3);
  });
}
function View_PrepareOrderItemsComponent_13(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'md-icon',[['md-list-icon',
      ''],['role','img'],['style','cursor:pointer']],[[2,'mat-icon',(null as any)],
      [2,'mat-list-icon',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.openInlineCut((<any>_v.parent).context.$implicit)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(9027584,(null as any),0,i3.MdIcon,[i1.ElementRef,i1.Renderer2,i3.MdIconRegistry],
          (null as any),(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdListIconCssMatStyler,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(0,['content_cut']))],
      (_ck,_v) => {
        _ck(_v,2,0);
      },(_ck,_v) => {
        const currVal_0:any = true;
        const currVal_1:any = true;
        _ck(_v,0,0,currVal_0,currVal_1);
      });
}
function View_PrepareOrderItemsComponent_14(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'md-icon',[['md-list-icon',
      ''],['role','img'],['style','cursor:pointer']],[[2,'mat-icon',(null as any)],
      [2,'mat-list-icon',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.overrideItemCut((<any>_v.parent).context.$implicit)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(9027584,(null as any),0,i3.MdIcon,[i1.ElementRef,i1.Renderer2,i3.MdIconRegistry],
          (null as any),(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdListIconCssMatStyler,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(0,['forward']))],
      (_ck,_v) => {
        _ck(_v,2,0);
      },(_ck,_v) => {
        const currVal_0:any = true;
        const currVal_1:any = true;
        _ck(_v,0,0,currVal_0,currVal_1);
      });
}
function View_PrepareOrderItemsComponent_15(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'md-icon',[['md-list-icon',
      ''],['role','img'],['style','cursor:pointer'],['title','Change Piece']],[[2,
      'mat-icon',(null as any)],[2,'mat-list-icon',(null as any)]],[[(null as any),
      'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.swapPiece((<any>_v.parent).context.$implicit)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },i2.View_MdIcon_0,i2.RenderType_MdIcon)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
      [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(9027584,(null as any),0,i3.MdIcon,[i1.ElementRef,i1.Renderer2,i3.MdIconRegistry],
          (null as any),(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdListIconCssMatStyler,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(0,['swap_horiz']))],
      (_ck,_v) => {
        _ck(_v,2,0);
      },(_ck,_v) => {
        const currVal_0:any = true;
        const currVal_1:any = true;
        _ck(_v,0,0,currVal_0,currVal_1);
      });
}
function View_PrepareOrderItemsComponent_4(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),49,'md-list-item',
      [['role','listitem']],[[2,'mat-list-item',(null as any)]],[[(null as any),'focus'],
          [(null as any),'blur']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('focus' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,2)._handleFocus()) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i1.ɵnov(_v,2)._handleBlur()) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i2.View_MdListItem_0,i2.RenderType_MdListItem)),i1.ɵdid(16384,(null as any),
      0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
      (null as any)),i1.ɵdid(1097728,(null as any),2,i3.MdListItem,[i1.Renderer2,i1.ElementRef,
      [2,i3.MdList],[2,i3.MdNavListCssMatStyler]],(null as any),(null as any)),i1.ɵqud(603979776,
      21,{_lines:1}),i1.ɵqud(335544320,22,{_hasAvatar:0}),(_l()(),i1.ɵted(2,['\n              '])),
      (_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),View_PrepareOrderItemsComponent_5)),
      i1.ɵdid(16384,(null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted(2,['\n              '])),(_l()(),
          i1.ɵand(16777216,(null as any),0,1,(null as any),View_PrepareOrderItemsComponent_6)),
      i1.ɵdid(16384,(null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted(2,['\n              '])),(_l()(),
          i1.ɵand(16777216,(null as any),0,1,(null as any),View_PrepareOrderItemsComponent_7)),
      i1.ɵdid(16384,(null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted(2,['\n              '])),(_l()(),
          i1.ɵeld(0,(null as any),1,17,'h4',[['md-line','']],[[2,'mat-line',(null as any)]],
              (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(16384,
          [[21,4]],0,i3.MdLine,([] as any[]),(null as any),(null as any)),(_l()(),
          i1.ɵted((null as any),['\n                '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),10,'span',[['style','height: 60%; color:darkgray']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['\n                  '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_PrepareOrderItemsComponent_8)),i1.ɵdid(16384,(null as any),
          0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n                  '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_PrepareOrderItemsComponent_9)),
      i1.ɵdid(16384,(null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n                  ( ',
          'm '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_PrepareOrderItemsComponent_10)),i1.ɵdid(16384,(null as any),0,i7.NgIf,
          [i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
          i1.ɵted((null as any),[' )\n                  - ','\n                '])),
      (_l()(),i1.ɵted((null as any),['\n\n\n                '])),(_l()(),i1.ɵand(16777216,
          (null as any),(null as any),1,(null as any),View_PrepareOrderItemsComponent_11)),
      i1.ɵdid(16384,(null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n              '])),
      (_l()(),i1.ɵted(2,['\n              '])),(_l()(),i1.ɵeld(0,(null as any),1,2,
          'p',[['md-line','']],[[2,'mat-line',(null as any)]],(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(16384,[[21,4]],0,i3.MdLine,([] as any[]),
          (null as any),(null as any)),(_l()(),i1.ɵted((null as any),[' ','/','/',
          ' '])),(_l()(),i1.ɵted(2,['\n\n              '])),(_l()(),i1.ɵand(16777216,
          (null as any),1,1,(null as any),View_PrepareOrderItemsComponent_12)),i1.ɵdid(16384,
          (null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(2,['\n\n              '])),(_l()(),i1.ɵand(16777216,
          (null as any),0,1,(null as any),View_PrepareOrderItemsComponent_13)),i1.ɵdid(16384,
          (null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(2,['\n              '])),(_l()(),i1.ɵand(16777216,
          (null as any),0,1,(null as any),View_PrepareOrderItemsComponent_14)),i1.ɵdid(16384,
          (null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(2,['\n              '])),(_l()(),i1.ɵand(16777216,
          (null as any),0,1,(null as any),View_PrepareOrderItemsComponent_15)),i1.ɵdid(16384,
          (null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i1.ɵted(2,['\n            ']))],(_ck,_v) => {
    const currVal_1:any = (_v.context.$implicit.sold || _v.context.$implicit.deleted);
    _ck(_v,7,0,currVal_1);
    const currVal_2:boolean = ((!_v.context.$implicit.checked && !_v.context.$implicit.sold) && !_v.context.$implicit.deleted);
    _ck(_v,10,0,currVal_2);
    const currVal_3:any = _v.context.$implicit.checked;
    _ck(_v,13,0,currVal_3);
    const currVal_5:any = (_v.context.$implicit.sold || _v.context.$implicit.deleted);
    _ck(_v,21,0,currVal_5);
    const currVal_6:boolean = (!_v.context.$implicit.sold && !_v.context.$implicit.deleted);
    _ck(_v,24,0,currVal_6);
    const currVal_8:any = ((_v.context.$implicit.quantity * 1) < (_v.context.$implicit.full_length * 1));
    _ck(_v,27,0,currVal_8);
    const currVal_10:any = _v.context.$implicit.prepared_pallet_id;
    _ck(_v,31,0,currVal_10);
    const currVal_15:any = _v.context.$implicit.tag;
    _ck(_v,39,0,currVal_15);
    const currVal_16:any = ((_v.context.$implicit.quantity * 1) < (_v.context.$implicit.full_length * 1));
    _ck(_v,42,0,currVal_16);
    const currVal_17:any = ((_v.context.$implicit.quantity * 1) < (_v.context.$implicit.full_length * 1));
    _ck(_v,45,0,currVal_17);
    const currVal_18:boolean = !_v.context.$implicit.defect;
    _ck(_v,48,0,currVal_18);
  },(_ck,_v) => {
    const currVal_0:any = true;
    _ck(_v,0,0,currVal_0);
    const currVal_4:any = true;
    _ck(_v,15,0,currVal_4);
    const currVal_7:any = _v.context.$implicit.quantity;
    _ck(_v,25,0,currVal_7);
    const currVal_9:any = _v.context.$implicit.grade_code;
    _ck(_v,28,0,currVal_9);
    const currVal_11:any = true;
    _ck(_v,34,0,currVal_11);
    const currVal_12:any = _v.context.$implicit.collection_name;
    const currVal_13:any = _v.context.$implicit.design_name;
    const currVal_14:any = _v.context.$implicit.color_name;
    _ck(_v,36,0,currVal_12,currVal_13,currVal_14);
  });
}
function View_PrepareOrderItemsComponent_3(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),23,'div',[['class',
      'padded-container'],['fxLayout','column'],['fxLayoutGap','30px'],['fxLayoutGap.lt-md',
      '14px']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(737280,(null as any),0,i8.LayoutDirective,[i6.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),i1.ɵdid(1720320,(null as any),
          0,i9.LayoutGapDirective,[i6.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i8.LayoutDirective]],
          {gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n          '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),17,'md-list',[['role','list']],[[2,
              'mat-list',(null as any)]],(null as any),(null as any),i2.View_MdList_0,
              i2.RenderType_MdList)),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(49152,(null as any),0,i3.MdList,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i3.MdListCssMatStyler,([] as any[]),(null as any),
          (null as any)),(_l()(),i1.ɵted(0,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),0,8,'md-list-item',[['role','listitem']],[[2,'mat-list-item',
              (null as any)]],[[(null as any),'focus'],[(null as any),'blur']],(_v,
              en,$event) => {
            var ad:boolean = true;
            if (('focus' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,12)._handleFocus()) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,12)._handleBlur()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },i2.View_MdListItem_0,i2.RenderType_MdListItem)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(1097728,(null as any),2,i3.MdListItem,
          [i1.Renderer2,i1.ElementRef,[2,i3.MdList],[2,i3.MdNavListCssMatStyler]],
          (null as any),(null as any)),i1.ɵqud(603979776,19,{_lines:1}),i1.ɵqud(335544320,
          20,{_hasAvatar:0}),(_l()(),i1.ɵted(2,['\n              '])),(_l()(),i1.ɵeld(0,
          (null as any),2,1,'span',[['style','border-bottom: 1px solid black']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['',''])),(_l()(),i1.ɵted(2,['\n            '])),(_l()(),i1.ɵted(0,['\n\n            '])),
      (_l()(),i1.ɵand(16777216,(null as any),0,1,(null as any),View_PrepareOrderItemsComponent_4)),
      i1.ɵdid(802816,(null as any),0,i7.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(0,
          ['\n          '])),(_l()(),i1.ɵted((null as any),['\n        ']))],(_ck,
      _v) => {
    const currVal_0:any = 'column';
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = '30px';
    const currVal_2:any = '14px';
    _ck(_v,2,0,currVal_1,currVal_2);
    const currVal_3:any = 'padded-container';
    _ck(_v,3,0,currVal_3);
    const currVal_7:any = _v.context.$implicit.pieces;
    _ck(_v,21,0,currVal_7);
  },(_ck,_v) => {
    const currVal_4:any = true;
    _ck(_v,5,0,currVal_4);
    const currVal_5:any = true;
    _ck(_v,10,0,currVal_5);
    const currVal_6:any = _v.context.$implicit.location;
    _ck(_v,17,0,currVal_6);
  });
}
function View_PrepareOrderItemsComponent_16(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),17,'md-input-container',
      ([] as any[]),[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_MdInputContainer_0,i2.RenderType_MdInputContainer)),i1.ɵdid(7389184,
      (null as any),6,i3.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,[2,i4.NgForm],
          [2,i4.FormGroupDirective]],(null as any),(null as any)),i1.ɵqud(335544320,
      29,{_mdInputChild:0}),i1.ɵqud(335544320,30,{_placeholderChild:0}),i1.ɵqud(603979776,
      31,{_errorChildren:1}),i1.ɵqud(603979776,32,{_hintChildren:1}),i1.ɵqud(603979776,
      33,{_prefixChildren:1}),i1.ɵqud(603979776,34,{_suffixChildren:1}),(_l()(),i1.ɵted(1,
      ['\n            '])),(_l()(),i1.ɵeld(0,(null as any),1,7,'input',[['mdInput',
      '']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
      (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],[2,
      'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
      (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
      0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
      'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
      'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('input' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,10)._handleInput($event.target.value)) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,10).onTouched()) !== false);
      ad = (pd_1 && ad);
    }
    if (('compositionstart' === en)) {
      const pd_2:any = ((<any>i1.ɵnov(_v,10)._compositionStart()) !== false);
      ad = (pd_2 && ad);
    }
    if (('compositionend' === en)) {
      const pd_3:any = ((<any>i1.ɵnov(_v,10)._compositionEnd($event.target.value)) !== false);
      ad = (pd_3 && ad);
    }
    if (('blur' === en)) {
      const pd_4:any = ((<any>i1.ɵnov(_v,15)._onBlur()) !== false);
      ad = (pd_4 && ad);
    }
    if (('focus' === en)) {
      const pd_5:any = ((<any>i1.ɵnov(_v,15)._onFocus()) !== false);
      ad = (pd_5 && ad);
    }
    if (('input' === en)) {
      const pd_6:any = ((<any>i1.ɵnov(_v,15)._onInput()) !== false);
      ad = (pd_6 && ad);
    }
    if (('ngModelChange' === en)) {
      const pd_7:any = ((<any>(_co._scanned = $event)) !== false);
      ad = (pd_7 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i4.DefaultValueAccessor,
      [i1.Renderer2,i1.ElementRef,[2,i4.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),
      i1.ɵprd(1024,(null as any),i4.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i4.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i4.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i4.NgControl,
          (null as any),[i4.NgModel]),i1.ɵdid(16384,(null as any),0,i4.NgControlStatus,
          [i4.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[29,4]],0,i3.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i4.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n          ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_24:any = _co._scanned;
    _ck(_v,12,0,currVal_24);
    const currVal_25:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,15,0,_ck(_v,16,0,
        i1.ɵnov((<any>_v.parent),0),'scan',_co._authService.getLanguage())),'');
    _ck(_v,15,0,currVal_25);
  },(_ck,_v) => {
    const currVal_0:any = (null as any);
    const currVal_1:any = true;
    const currVal_2:any = i1.ɵnov(_v,1)._isErrorState();
    const currVal_3:any = i1.ɵnov(_v,1)._mdInputChild.focused;
    const currVal_4:any = i1.ɵnov(_v,1)._shouldForward('untouched');
    const currVal_5:any = i1.ɵnov(_v,1)._shouldForward('touched');
    const currVal_6:any = i1.ɵnov(_v,1)._shouldForward('pristine');
    const currVal_7:any = i1.ɵnov(_v,1)._shouldForward('dirty');
    const currVal_8:any = i1.ɵnov(_v,1)._shouldForward('valid');
    const currVal_9:any = i1.ɵnov(_v,1)._shouldForward('invalid');
    const currVal_10:any = i1.ɵnov(_v,1)._shouldForward('pending');
    _ck(_v,0,1,[currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8,currVal_9,currVal_10]);
    const currVal_11:any = i1.ɵnov(_v,14).ngClassUntouched;
    const currVal_12:any = i1.ɵnov(_v,14).ngClassTouched;
    const currVal_13:any = i1.ɵnov(_v,14).ngClassPristine;
    const currVal_14:any = i1.ɵnov(_v,14).ngClassDirty;
    const currVal_15:any = i1.ɵnov(_v,14).ngClassValid;
    const currVal_16:any = i1.ɵnov(_v,14).ngClassInvalid;
    const currVal_17:any = i1.ɵnov(_v,14).ngClassPending;
    const currVal_18:any = true;
    const currVal_19:any = i1.ɵnov(_v,15).id;
    const currVal_20:any = i1.ɵnov(_v,15).placeholder;
    const currVal_21:any = i1.ɵnov(_v,15).disabled;
    const currVal_22:any = i1.ɵnov(_v,15).required;
    const currVal_23:any = (i1.ɵnov(_v,15).ariaDescribedby || (null as any));
    _ck(_v,9,1,[currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,
        currVal_17,currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23]);
  });
}
function View_PrepareOrderItemsComponent_17(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),17,'md-input-container',
      ([] as any[]),[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
          (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1)._focusInput()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_MdInputContainer_0,i2.RenderType_MdInputContainer)),i1.ɵdid(7389184,
      (null as any),6,i3.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,[2,i4.NgForm],
          [2,i4.FormGroupDirective]],(null as any),(null as any)),i1.ɵqud(335544320,
      35,{_mdInputChild:0}),i1.ɵqud(335544320,36,{_placeholderChild:0}),i1.ɵqud(603979776,
      37,{_errorChildren:1}),i1.ɵqud(603979776,38,{_hintChildren:1}),i1.ɵqud(603979776,
      39,{_prefixChildren:1}),i1.ɵqud(603979776,40,{_suffixChildren:1}),(_l()(),i1.ɵted(1,
      ['\n            '])),(_l()(),i1.ɵeld(0,(null as any),1,7,'textarea',[['mdInput',
      ''],['rows','10']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
      [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
      [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)],[2,'mat-input-element',
          (null as any)],[8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',
          0],[1,'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
      'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
      'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('input' === en)) {
      const pd_0:any = ((<any>i1.ɵnov(_v,10)._handleInput($event.target.value)) !== false);
      ad = (pd_0 && ad);
    }
    if (('blur' === en)) {
      const pd_1:any = ((<any>i1.ɵnov(_v,10).onTouched()) !== false);
      ad = (pd_1 && ad);
    }
    if (('compositionstart' === en)) {
      const pd_2:any = ((<any>i1.ɵnov(_v,10)._compositionStart()) !== false);
      ad = (pd_2 && ad);
    }
    if (('compositionend' === en)) {
      const pd_3:any = ((<any>i1.ɵnov(_v,10)._compositionEnd($event.target.value)) !== false);
      ad = (pd_3 && ad);
    }
    if (('blur' === en)) {
      const pd_4:any = ((<any>i1.ɵnov(_v,15)._onBlur()) !== false);
      ad = (pd_4 && ad);
    }
    if (('focus' === en)) {
      const pd_5:any = ((<any>i1.ɵnov(_v,15)._onFocus()) !== false);
      ad = (pd_5 && ad);
    }
    if (('input' === en)) {
      const pd_6:any = ((<any>i1.ɵnov(_v,15)._onInput()) !== false);
      ad = (pd_6 && ad);
    }
    if (('ngModelChange' === en)) {
      const pd_7:any = ((<any>(_co._scanned = $event)) !== false);
      ad = (pd_7 && ad);
    }
    return ad;
  },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i4.DefaultValueAccessor,
      [i1.Renderer2,i1.ElementRef,[2,i4.COMPOSITION_BUFFER_MODE]],(null as any),(null as any)),
      i1.ɵprd(1024,(null as any),i4.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i4.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i4.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i4.NgControl,
          (null as any),[i4.NgModel]),i1.ɵdid(16384,(null as any),0,i4.NgControlStatus,
          [i4.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[35,4]],0,i3.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i4.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n          ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_24:any = _co._scanned;
    _ck(_v,12,0,currVal_24);
    const currVal_25:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,15,0,_ck(_v,16,0,
        i1.ɵnov((<any>_v.parent),0),'scan',_co._authService.getLanguage())),'');
    _ck(_v,15,0,currVal_25);
  },(_ck,_v) => {
    const currVal_0:any = (null as any);
    const currVal_1:any = true;
    const currVal_2:any = i1.ɵnov(_v,1)._isErrorState();
    const currVal_3:any = i1.ɵnov(_v,1)._mdInputChild.focused;
    const currVal_4:any = i1.ɵnov(_v,1)._shouldForward('untouched');
    const currVal_5:any = i1.ɵnov(_v,1)._shouldForward('touched');
    const currVal_6:any = i1.ɵnov(_v,1)._shouldForward('pristine');
    const currVal_7:any = i1.ɵnov(_v,1)._shouldForward('dirty');
    const currVal_8:any = i1.ɵnov(_v,1)._shouldForward('valid');
    const currVal_9:any = i1.ɵnov(_v,1)._shouldForward('invalid');
    const currVal_10:any = i1.ɵnov(_v,1)._shouldForward('pending');
    _ck(_v,0,1,[currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8,currVal_9,currVal_10]);
    const currVal_11:any = i1.ɵnov(_v,14).ngClassUntouched;
    const currVal_12:any = i1.ɵnov(_v,14).ngClassTouched;
    const currVal_13:any = i1.ɵnov(_v,14).ngClassPristine;
    const currVal_14:any = i1.ɵnov(_v,14).ngClassDirty;
    const currVal_15:any = i1.ɵnov(_v,14).ngClassValid;
    const currVal_16:any = i1.ɵnov(_v,14).ngClassInvalid;
    const currVal_17:any = i1.ɵnov(_v,14).ngClassPending;
    const currVal_18:any = true;
    const currVal_19:any = i1.ɵnov(_v,15).id;
    const currVal_20:any = i1.ɵnov(_v,15).placeholder;
    const currVal_21:any = i1.ɵnov(_v,15).disabled;
    const currVal_22:any = i1.ɵnov(_v,15).required;
    const currVal_23:any = (i1.ɵnov(_v,15).ariaDescribedby || (null as any));
    _ck(_v,9,1,[currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,currVal_16,
        currVal_17,currVal_18,currVal_19,currVal_20,currVal_21,currVal_22,currVal_23]);
  });
}
export function View_PrepareOrderItemsComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵpid(0,i10.TranslatePipe,([] as any[])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),305,'div',[['fxLayout','column']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i8.LayoutDirective,
      [i6.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,'layout']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          301,'div',[['class','boxed-content-wrapper cards-no-gaps']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,
          (null as any),(null as any),297,'md-card',([] as any[]),[[2,'mat-card',(null as any)]],
          (null as any),(null as any),i2.View_MdCard_0,i2.RenderType_MdCard)),i1.ɵdid(16384,
          (null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(49152,(null as any),
          0,i3.MdCard,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted(0,
          ['\n      '])),(_l()(),i1.ɵeld(0,(null as any),0,28,'md-card-header',[['fxLayout',
          'column']],[[2,'mat-card-header',(null as any)]],(null as any),(null as any),
          i2.View_MdCardHeader_0,i2.RenderType_MdCardHeader)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(49152,(null as any),0,i3.MdCardHeader,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(737280,(null as any),
          0,i8.LayoutDirective,[i6.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,
              'layout']},(null as any)),(_l()(),i1.ɵted(2,['\n        '])),(_l()(),
          i1.ɵeld(0,(null as any),1,15,'md-card-title',([] as any[]),[[2,'mat-card-title',
              (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i3.MdCardTitle,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n          '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),10,'span',
          [['class','md-title'],['fxFlex','100']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i11.FlexDirective,
          [i6.MediaMonitor,i1.ElementRef,i1.Renderer2,[3,i8.LayoutDirective],[3,i12.LayoutWrapDirective]],
          {flex:[0,'flex']},(null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,
          [i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,
              i1.Renderer2],{classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n            PDA /\n            '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),4,'a',([] as any[]),[[1,'target',0],[8,'href',4]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,25).onClick($event.button,$event.ctrlKey,
                  $event.metaKey,$event.shiftKey)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(671744,(null as any),0,i13.RouterLinkWithHref,
          [i13.Router,i13.ActivatedRoute,i7.LocationStrategy],{routerLink:[0,'routerLink']},
          (null as any)),i1.ɵpad(1),(_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),
      (_l()(),i1.ɵted((null as any),[' /\n            ',' / ','\n          '])),i1.ɵppd(2),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵted(2,['\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),1,5,'md-card-subtitle',[['class','bg-grey color-white text-only']],
          [[2,'mat-card-subtitle',(null as any)]],(null as any),(null as any),(null as any),
          (null as any))),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i3.MdCardSubtitle,([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['',''])),i1.ɵppd(2),(_l()(),
          i1.ɵted(2,['\n      '])),(_l()(),i1.ɵted(0,['\n\n\n      '])),(_l()(),i1.ɵeld(0,
          (null as any),0,27,'md-card-content',[['fxLayout','column']],[[2,'mat-card-content',
              (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i3.MdCardContent,([] as any[]),(null as any),(null as any)),i1.ɵdid(737280,
          (null as any),0,i8.LayoutDirective,[i6.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted((null as any),['\n\n        '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),8,'div',[['flex',''],['layout-margin',
          '']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted((null as any),['\n          '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),1,'span',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',''])),(_l()(),
          i1.ɵted((null as any),['\n          '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),2,'md-progress-bar',[['aria-valuemax','100'],['aria-valuemin',
              '0'],['mode','determinate'],['role','progressbar']],[[2,'mat-primary',
              (null as any)],[2,'mat-accent',(null as any)],[2,'mat-warn',(null as any)],
              [2,'mat-progress-bar',(null as any)],[1,'aria-valuenow',0],[1,'mode',
                  0]],(null as any),(null as any),i2.View_MdProgressBar_0,i2.RenderType_MdProgressBar)),
      i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(49152,(null as any),
          0,i3.MdProgressBar,([] as any[]),{value:[0,'value'],mode:[1,'mode']},(null as any)),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),11,'div',
          [['class','padded-container'],['fxLayout','column'],['fxLayoutGap','30px'],
              ['fxLayoutGap.lt-md','14px'],['style','max-width: 250px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i8.LayoutDirective,[i6.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout']},(null as any)),i1.ɵdid(1720320,(null as any),0,i9.LayoutGapDirective,
          [i6.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i8.LayoutDirective]],{gap:[0,
              'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n          '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),2,'h4',([] as any[]),(null as any),
              (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          [' ',':'])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),['\n          '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted((null as any),
          ['',''])),(_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n      '])),(_l()(),i1.ɵted(0,['\n\n\n      '])),(_l()(),i1.ɵeld(0,(null as any),
          0,63,'md-card-content',([] as any[]),[[2,'mat-card-content',(null as any)]],
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(16384,
          (null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i3.MdCardContent,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),24,'div',
          [['class','padded-container'],['fxLayout','column'],['fxLayoutGap','30px'],
              ['fxLayoutGap.lt-md','14px'],['style','max-width: 250px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i8.LayoutDirective,[i6.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout']},(null as any)),i1.ɵdid(1720320,(null as any),0,i9.LayoutGapDirective,
          [i6.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i8.LayoutDirective]],{gap:[0,
              'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n          '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
              '47%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,80)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdInputContainer_0,i2.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i3.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i4.NgForm],[2,i4.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,1,{_mdInputChild:0}),i1.ɵqud(335544320,2,{_placeholderChild:0}),
      i1.ɵqud(603979776,3,{_errorChildren:1}),i1.ɵqud(603979776,4,{_hintChildren:1}),
      i1.ɵqud(603979776,5,{_prefixChildren:1}),i1.ɵqud(603979776,6,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i11.FlexDirective,[i6.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i8.LayoutDirective],[3,i12.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[2,'mat-input-element',(null as any)],
              [8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,
                  'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i14.PrepareOrderItemsComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,90)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,90).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,90)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,90)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,95)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,95)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,95)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co._pallet = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i4.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i4.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i4.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i4.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i4.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i4.NgControl,
          (null as any),[i4.NgModel]),i1.ɵdid(16384,(null as any),0,i4.NgControlStatus,
          [i4.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[1,4]],0,i3.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i4.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n          '])),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵted((null as any),['\n\n        '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),12,'div',[['class','padded-container'],
              ['fxLayout','row'],['fxLayout.lt-md','column'],['fxLayoutGap','30px'],
              ['fxLayoutGap.lt-md','14px']],(null as any),(null as any),(null as any),
              (null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i8.LayoutDirective,
          [i6.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,
              'layoutLtMd']},(null as any)),i1.ɵdid(1720320,(null as any),0,i9.LayoutGapDirective,
          [i6.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i8.LayoutDirective]],{gap:[0,
              'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n          '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),6,'md-slide-toggle',([] as any[]),
              [[2,'mat-slide-toggle',(null as any)],[2,'mat-checked',(null as any)],
                  [2,'mat-disabled',(null as any)],[2,'mat-slide-toggle-label-before',
                      (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',
                      (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                      (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
                      (null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
                  'ngModelChange']],(_v,en,$event) => {
                var ad:boolean = true;
                var _co:i14.PrepareOrderItemsComponent = _v.component;
                if (('ngModelChange' === en)) {
                  const pd_0:any = ((<any>(_co.multiMode = $event)) !== false);
                  ad = (pd_0 && ad);
                }
                return ad;
              },i2.View_MdSlideToggle_0,i2.RenderType_MdSlideToggle)),i1.ɵdid(1228800,
          (null as any),0,i3.MdSlideToggle,[i1.ElementRef,i1.Renderer2,i3.FocusOriginMonitor],
          (null as any),(null as any)),i1.ɵprd(1024,(null as any),i4.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i3.MdSlideToggle]),i1.ɵdid(671744,(null as any),0,i4.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i4.NgControl,
          (null as any),[i4.NgModel]),i1.ɵdid(16384,(null as any),0,i4.NgControlStatus,
          [i4.NgControl],(null as any),(null as any)),(_l()(),i1.ɵted(0,['Multi-piece mode'])),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),18,'div',
          [['class','padded-container'],['fxLayout','column'],['fxLayoutGap','30px'],
              ['fxLayoutGap.lt-md','14px'],['style','max-width: 250px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i8.LayoutDirective,[i6.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout']},(null as any)),i1.ɵdid(1720320,(null as any),0,i9.LayoutGapDirective,
          [i6.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i8.LayoutDirective]],{gap:[0,
              'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n\n          '])),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PrepareOrderItemsComponent_1)),
      i1.ɵdid(16384,(null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n          '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PrepareOrderItemsComponent_2)),
      i1.ɵdid(16384,(null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n\n          '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class','bg-blue color-white mat-button'],
          ['color','primary'],['md-button','']],[[8,'disabled',0]],[[(null as any),
          'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i14.PrepareOrderItemsComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.markScanned(_co._scanned)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,
          i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
          (null as any)),i1.ɵdid(180224,(null as any),0,i3.MdButton,[i1.ElementRef,
          i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],{color:[0,'color']},(null as any)),
      i1.ɵdid(16384,(null as any),0,i3.MdButtonCssMatStyler,([] as any[]),(null as any),
          (null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i6.MediaMonitor,
          i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
          {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n      '])),(_l()(),i1.ɵted(0,['\n\n      '])),(_l()(),i1.ɵeld(0,(null as any),
          0,44,'md-card-actions',([] as any[]),[[2,'mat-card-actions',(null as any)]],
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(16384,
          (null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
              i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i3.MdCardActions,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),39,'div',
          [['class','table-control-buttons'],['fxFlex',''],['fxFlexAlign','start'],
              ['fxFlexAlign.lt-md','center'],['fxLayoutGap','12px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(1720320,
          (null as any),0,i9.LayoutGapDirective,[i6.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [8,(null as any)]],{gap:[0,'gap']},(null as any)),i1.ɵdid(737280,(null as any),
          0,i11.FlexDirective,[i6.MediaMonitor,i1.ElementRef,i1.Renderer2,[3,i8.LayoutDirective],
              [3,i12.LayoutWrapDirective]],{flex:[0,'flex']},(null as any)),i1.ɵdid(737280,
          (null as any),0,i15.FlexAlignDirective,[i6.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {align:[0,'align'],alignLtMd:[1,'alignLtMd']},(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n          '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),6,'button',[['class','bg-blue color-white mat-button'],
              ['color','primary'],['md-button','']],[[8,'disabled',0]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i14.PrepareOrderItemsComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.prepareOrder()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i3.MdButton,
          [i1.ElementRef,i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n          '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',
          [['class','bg-blue color-white mat-button'],['color','primary'],['md-button',
              '']],[[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i14.PrepareOrderItemsComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.addPiece()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i3.MdButton,
          [i1.ElementRef,i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n          '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',
          [['class','bg-blue color-white mat-button'],['color','primary'],['md-button',
              '']],[[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i14.PrepareOrderItemsComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.savePreparationStatus()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i3.MdButton,
          [i1.ElementRef,i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n          '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),8,'button',
          [['class','bg-red color-white mat-button'],['color','warn'],['md-button',
              '']],[[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,170).onClick()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i13.RouterLink,[i13.Router,i13.ActivatedRoute,[8,(null as any)],i1.Renderer2,
              i1.ElementRef],{routerLink:[0,'routerLink']},(null as any)),i1.ɵpad(1),
      i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(180224,(null as any),
          0,i3.MdButton,[i1.ElementRef,i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],
          {color:[0,'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵted(0,
          ['\n\n'])),(_l()(),i1.ɵeld(0,(null as any),0,0,'hr',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i1.ɵted(0,
          ['\n      '])),(_l()(),i1.ɵeld(0,(null as any),0,7,'md-card-content',[['fxLayout',
          'column']],[[2,'mat-card-content',(null as any)]],(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i3.MdCardContent,([] as any[]),(null as any),(null as any)),
      i1.ɵdid(737280,(null as any),0,i8.LayoutDirective,[i6.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        \n        '])),(_l()(),i1.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_PrepareOrderItemsComponent_3)),i1.ɵdid(802816,(null as any),
          0,i7.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,i1.IterableDiffers],{ngForOf:[0,
              'ngForOf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n      '])),
      (_l()(),i1.ɵted(0,['\n'])),(_l()(),i1.ɵeld(0,(null as any),0,0,'hr',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i1.ɵted(0,['\n\n      '])),(_l()(),i1.ɵeld(0,(null as any),0,63,'md-card-content',
          ([] as any[]),[[2,'mat-card-content',(null as any)]],(null as any),(null as any),
          (null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,
          [[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),(null as any)),
      i1.ɵdid(16384,(null as any),0,i3.MdCardContent,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵeld(0,(null as any),
          (null as any),24,'div',[['class','padded-container'],['fxLayout','column'],
              ['fxLayoutGap','30px'],['fxLayoutGap.lt-md','14px'],['style','max-width: 250px']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(737280,(null as any),0,i8.LayoutDirective,[i6.MediaMonitor,i1.ElementRef,
          i1.Renderer2],{layout:[0,'layout']},(null as any)),i1.ɵdid(1720320,(null as any),
          0,i9.LayoutGapDirective,[i6.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i8.LayoutDirective]],
          {gap:[0,'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n          '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),18,'md-input-container',[['fxFlex',
              '47%']],[[1,'align',0],[2,'mat-input-container',(null as any)],[2,'mat-input-invalid',
              (null as any)],[2,'mat-focused',(null as any)],[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,204)._focusInput()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdInputContainer_0,i2.RenderType_MdInputContainer)),i1.ɵdid(7389184,
          (null as any),6,i3.MdInputContainer,[i1.ElementRef,i1.ChangeDetectorRef,
              [2,i4.NgForm],[2,i4.FormGroupDirective]],(null as any),(null as any)),
      i1.ɵqud(335544320,23,{_mdInputChild:0}),i1.ɵqud(335544320,24,{_placeholderChild:0}),
      i1.ɵqud(603979776,25,{_errorChildren:1}),i1.ɵqud(603979776,26,{_hintChildren:1}),
      i1.ɵqud(603979776,27,{_prefixChildren:1}),i1.ɵqud(603979776,28,{_suffixChildren:1}),
      i1.ɵdid(737280,(null as any),0,i11.FlexDirective,[i6.MediaMonitor,i1.ElementRef,
          i1.Renderer2,[3,i8.LayoutDirective],[3,i12.LayoutWrapDirective]],{flex:[0,
          'flex']},(null as any)),(_l()(),i1.ɵted(1,['\n            '])),(_l()(),i1.ɵeld(0,
          (null as any),1,7,'input',[['mdInput','']],[[2,'ng-untouched',(null as any)],
              [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                  (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
              [2,'ng-pending',(null as any)],[2,'mat-input-element',(null as any)],
              [8,'id',0],[8,'placeholder',0],[8,'disabled',0],[8,'required',0],[1,
                  'aria-describedby',0]],[[(null as any),'ngModelChange'],[(null as any),
              'input'],[(null as any),'blur'],[(null as any),'compositionstart'],[(null as any),
              'compositionend'],[(null as any),'focus']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i14.PrepareOrderItemsComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,214)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i1.ɵnov(_v,214).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i1.ɵnov(_v,214)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i1.ɵnov(_v,214)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('blur' === en)) {
              const pd_4:any = ((<any>i1.ɵnov(_v,219)._onBlur()) !== false);
              ad = (pd_4 && ad);
            }
            if (('focus' === en)) {
              const pd_5:any = ((<any>i1.ɵnov(_v,219)._onFocus()) !== false);
              ad = (pd_5 && ad);
            }
            if (('input' === en)) {
              const pd_6:any = ((<any>i1.ɵnov(_v,219)._onInput()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co._pallet = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i1.ɵdid(16384,(null as any),0,i4.DefaultValueAccessor,
          [i1.Renderer2,i1.ElementRef,[2,i4.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i1.ɵprd(1024,(null as any),i4.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i4.DefaultValueAccessor]),i1.ɵdid(671744,(null as any),0,i4.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i4.NgControl,
          (null as any),[i4.NgModel]),i1.ɵdid(16384,(null as any),0,i4.NgControlStatus,
          [i4.NgControl],(null as any),(null as any)),i1.ɵdid(16384,[[23,4]],0,i3.MdInputDirective,
          [i1.ElementRef,i1.Renderer2,[2,i4.NgControl]],{placeholder:[0,'placeholder']},
          (null as any)),i1.ɵppd(2),(_l()(),i1.ɵted(1,['\n          '])),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵted((null as any),['\n\n        '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),12,'div',[['class','padded-container'],
              ['fxLayout','row'],['fxLayout.lt-md','column'],['fxLayoutGap','30px'],
              ['fxLayoutGap.lt-md','14px']],(null as any),(null as any),(null as any),
              (null as any),(null as any))),i1.ɵdid(737280,(null as any),0,i8.LayoutDirective,
          [i6.MediaMonitor,i1.ElementRef,i1.Renderer2],{layout:[0,'layout'],layoutLtMd:[1,
              'layoutLtMd']},(null as any)),i1.ɵdid(1720320,(null as any),0,i9.LayoutGapDirective,
          [i6.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i8.LayoutDirective]],{gap:[0,
              'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n          '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),6,'md-slide-toggle',([] as any[]),
              [[2,'mat-slide-toggle',(null as any)],[2,'mat-checked',(null as any)],
                  [2,'mat-disabled',(null as any)],[2,'mat-slide-toggle-label-before',
                      (null as any)],[2,'ng-untouched',(null as any)],[2,'ng-touched',
                      (null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
                      (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',
                      (null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
                  'ngModelChange']],(_v,en,$event) => {
                var ad:boolean = true;
                var _co:i14.PrepareOrderItemsComponent = _v.component;
                if (('ngModelChange' === en)) {
                  const pd_0:any = ((<any>(_co.multiMode = $event)) !== false);
                  ad = (pd_0 && ad);
                }
                return ad;
              },i2.View_MdSlideToggle_0,i2.RenderType_MdSlideToggle)),i1.ɵdid(1228800,
          (null as any),0,i3.MdSlideToggle,[i1.ElementRef,i1.Renderer2,i3.FocusOriginMonitor],
          (null as any),(null as any)),i1.ɵprd(1024,(null as any),i4.NG_VALUE_ACCESSOR,
          (p0_0:any) => {
            return [p0_0];
          },[i3.MdSlideToggle]),i1.ɵdid(671744,(null as any),0,i4.NgModel,[[8,(null as any)],
          [8,(null as any)],[8,(null as any)],[2,i4.NG_VALUE_ACCESSOR]],{model:[0,
          'model']},{update:'ngModelChange'}),i1.ɵprd(2048,(null as any),i4.NgControl,
          (null as any),[i4.NgModel]),i1.ɵdid(16384,(null as any),0,i4.NgControlStatus,
          [i4.NgControl],(null as any),(null as any)),(_l()(),i1.ɵted(0,['Multi-piece mode'])),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),18,'div',
          [['class','padded-container'],['fxLayout','column'],['fxLayoutGap','30px'],
              ['fxLayoutGap.lt-md','14px'],['style','max-width: 250px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(737280,
          (null as any),0,i8.LayoutDirective,[i6.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {layout:[0,'layout']},(null as any)),i1.ɵdid(1720320,(null as any),0,i9.LayoutGapDirective,
          [i6.MediaMonitor,i1.ElementRef,i1.Renderer2,[2,i8.LayoutDirective]],{gap:[0,
              'gap'],gapLtMd:[1,'gapLtMd']},(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n\n          '])),(_l()(),
          i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PrepareOrderItemsComponent_16)),
      i1.ɵdid(16384,(null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n          '])),
      (_l()(),i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_PrepareOrderItemsComponent_17)),
      i1.ɵdid(16384,(null as any),0,i7.NgIf,[i1.ViewContainerRef,i1.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i1.ɵted((null as any),['\n\n          '])),
      (_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',[['class','bg-blue color-white mat-button'],
          ['color','primary'],['md-button','']],[[8,'disabled',0]],[[(null as any),
          'click']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i14.PrepareOrderItemsComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.markScanned(_co._scanned)) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),0,
          i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],(null as any),
          (null as any)),i1.ɵdid(180224,(null as any),0,i3.MdButton,[i1.ElementRef,
          i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],{color:[0,'color']},(null as any)),
      i1.ɵdid(16384,(null as any),0,i3.MdButtonCssMatStyler,([] as any[]),(null as any),
          (null as any)),i1.ɵdid(933888,(null as any),0,i5.ClassDirective,[i6.MediaMonitor,
          i1.IterableDiffers,i1.KeyValueDiffers,i1.ElementRef,i1.Renderer,i1.Renderer2],
          {classBase:[0,'classBase']},(null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),
      (_l()(),i1.ɵted((null as any),['\n        '])),(_l()(),i1.ɵted((null as any),
          ['\n        \n      '])),(_l()(),i1.ɵted(0,['\n\n\n      '])),(_l()(),i1.ɵeld(0,
          (null as any),0,44,'md-card-actions',([] as any[]),[[2,'mat-card-actions',
              (null as any)]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(16384,(null as any),
          0,i3.MdCardActions,([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),39,'div',
          [['class','table-control-buttons'],['fxFlex',''],['fxFlexAlign','start'],
              ['fxFlexAlign.lt-md','center'],['fxLayoutGap','12px']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),i1.ɵdid(1720320,
          (null as any),0,i9.LayoutGapDirective,[i6.MediaMonitor,i1.ElementRef,i1.Renderer2,
              [8,(null as any)]],{gap:[0,'gap']},(null as any)),i1.ɵdid(737280,(null as any),
          0,i11.FlexDirective,[i6.MediaMonitor,i1.ElementRef,i1.Renderer2,[3,i8.LayoutDirective],
              [3,i12.LayoutWrapDirective]],{flex:[0,'flex']},(null as any)),i1.ɵdid(737280,
          (null as any),0,i15.FlexAlignDirective,[i6.MediaMonitor,i1.ElementRef,i1.Renderer2],
          {align:[0,'align'],alignLtMd:[1,'alignLtMd']},(null as any)),i1.ɵdid(933888,
          (null as any),0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted((null as any),['\n          '])),(_l()(),
          i1.ɵeld(0,(null as any),(null as any),6,'button',[['class','bg-blue color-white mat-button'],
              ['color','primary'],['md-button','']],[[8,'disabled',0]],[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i14.PrepareOrderItemsComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.prepareOrder()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i3.MdButton,
          [i1.ElementRef,i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n          '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',
          [['class','bg-blue color-white mat-button'],['color','primary'],['md-button',
              '']],[[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i14.PrepareOrderItemsComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.addPiece()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i3.MdButton,
          [i1.ElementRef,i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n          '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),6,'button',
          [['class','bg-blue color-white mat-button'],['color','primary'],['md-button',
              '']],[[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i14.PrepareOrderItemsComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.savePreparationStatus()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],i1.ElementRef],
          (null as any),(null as any)),i1.ɵdid(180224,(null as any),0,i3.MdButton,
          [i1.ElementRef,i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],{color:[0,
              'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n          '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),8,'button',
          [['class','bg-red color-white mat-button'],['color','warn'],['md-button',
              '']],[[8,'disabled',0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('click' === en)) {
              const pd_0:any = ((<any>i1.ɵnov(_v,294).onClick()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i2.View_MdButton_0,i2.RenderType_MdButton)),i1.ɵdid(16384,(null as any),
          0,i13.RouterLink,[i13.Router,i13.ActivatedRoute,[8,(null as any)],i1.Renderer2,
              i1.ElementRef],{routerLink:[0,'routerLink']},(null as any)),i1.ɵpad(1),
      i1.ɵdid(16384,(null as any),0,i3.MdPrefixRejector,[[2,i3.MATERIAL_COMPATIBILITY_MODE],
          i1.ElementRef],(null as any),(null as any)),i1.ɵdid(180224,(null as any),
          0,i3.MdButton,[i1.ElementRef,i1.Renderer2,i3.Platform,i3.FocusOriginMonitor],
          {color:[0,'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i3.MdButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(933888,(null as any),
          0,i5.ClassDirective,[i6.MediaMonitor,i1.IterableDiffers,i1.KeyValueDiffers,
              i1.ElementRef,i1.Renderer,i1.Renderer2],{classBase:[0,'classBase']},
          (null as any)),(_l()(),i1.ɵted(0,['',''])),i1.ɵppd(2),(_l()(),i1.ɵted((null as any),
          ['\n        '])),(_l()(),i1.ɵted((null as any),['\n      '])),(_l()(),i1.ɵted(0,
          ['\n    '])),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵted((null as any),
          ['\n'])),(_l()(),i1.ɵted((null as any),['\n']))],(_ck,_v) => {
    var _co:i14.PrepareOrderItemsComponent = _v.component;
    const currVal_0:any = 'column';
    _ck(_v,2,0,currVal_0);
    const currVal_1:any = 'boxed-content-wrapper cards-no-gaps';
    _ck(_v,5,0,currVal_1);
    const currVal_4:any = 'column';
    _ck(_v,14,0,currVal_4);
    const currVal_6:any = '100';
    _ck(_v,21,0,currVal_6);
    const currVal_7:any = 'md-title';
    _ck(_v,22,0,currVal_7);
    const currVal_10:any = _ck(_v,26,0,'/pda/shipping');
    _ck(_v,25,0,currVal_10);
    const currVal_15:any = 'bg-grey color-white text-only';
    _ck(_v,36,0,currVal_15);
    const currVal_18:any = 'column';
    _ck(_v,44,0,currVal_18);
    const currVal_26:any = _co.preparedStatusValue();
    const currVal_27:any = 'determinate';
    _ck(_v,53,0,currVal_26,currVal_27);
    const currVal_28:any = 'column';
    _ck(_v,57,0,currVal_28);
    const currVal_29:any = '30px';
    const currVal_30:any = '14px';
    _ck(_v,58,0,currVal_29,currVal_30);
    const currVal_31:any = 'padded-container';
    _ck(_v,59,0,currVal_31);
    const currVal_35:any = 'column';
    _ck(_v,75,0,currVal_35);
    const currVal_36:any = '30px';
    const currVal_37:any = '14px';
    _ck(_v,76,0,currVal_36,currVal_37);
    const currVal_38:any = 'padded-container';
    _ck(_v,77,0,currVal_38);
    const currVal_50:any = '47%';
    _ck(_v,87,0,currVal_50);
    const currVal_64:any = _co._pallet;
    _ck(_v,92,0,currVal_64);
    const currVal_65:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,95,0,_ck(_v,96,0,
        i1.ɵnov(_v,0),'pallet',_co._authService.getLanguage())),'');
    _ck(_v,95,0,currVal_65);
    const currVal_66:any = 'row';
    const currVal_67:any = 'column';
    _ck(_v,101,0,currVal_66,currVal_67);
    const currVal_68:any = '30px';
    const currVal_69:any = '14px';
    _ck(_v,102,0,currVal_68,currVal_69);
    const currVal_70:any = 'padded-container';
    _ck(_v,103,0,currVal_70);
    const currVal_82:any = _co.multiMode;
    _ck(_v,108,0,currVal_82);
    const currVal_83:any = 'column';
    _ck(_v,115,0,currVal_83);
    const currVal_84:any = '30px';
    const currVal_85:any = '14px';
    _ck(_v,116,0,currVal_84,currVal_85);
    const currVal_86:any = 'padded-container';
    _ck(_v,117,0,currVal_86);
    const currVal_87:boolean = !_co.multiMode;
    _ck(_v,120,0,currVal_87);
    const currVal_88:any = _co.multiMode;
    _ck(_v,123,0,currVal_88);
    const currVal_90:any = 'primary';
    _ck(_v,127,0,currVal_90);
    const currVal_91:any = 'bg-blue color-white';
    _ck(_v,129,0,currVal_91);
    const currVal_94:any = '12px';
    _ck(_v,140,0,currVal_94);
    const currVal_95:any = '';
    _ck(_v,141,0,currVal_95);
    const currVal_96:any = 'start';
    const currVal_97:any = 'center';
    _ck(_v,142,0,currVal_96,currVal_97);
    const currVal_98:any = 'table-control-buttons';
    _ck(_v,143,0,currVal_98);
    const currVal_100:any = 'primary';
    _ck(_v,147,0,currVal_100);
    const currVal_101:any = 'bg-blue color-white';
    _ck(_v,149,0,currVal_101);
    const currVal_104:any = 'primary';
    _ck(_v,155,0,currVal_104);
    const currVal_105:any = 'bg-blue color-white';
    _ck(_v,157,0,currVal_105);
    const currVal_108:any = 'primary';
    _ck(_v,163,0,currVal_108);
    const currVal_109:any = 'bg-blue color-white';
    _ck(_v,165,0,currVal_109);
    const currVal_112:any = _ck(_v,171,0,'/pda/shipping/prepareOrder');
    _ck(_v,170,0,currVal_112);
    const currVal_113:any = 'warn';
    _ck(_v,173,0,currVal_113);
    const currVal_114:any = 'bg-red color-white';
    _ck(_v,175,0,currVal_114);
    const currVal_117:any = 'column';
    _ck(_v,186,0,currVal_117);
    const currVal_118:any = _co.grouped_items;
    _ck(_v,189,0,currVal_118);
    const currVal_120:any = 'column';
    _ck(_v,199,0,currVal_120);
    const currVal_121:any = '30px';
    const currVal_122:any = '14px';
    _ck(_v,200,0,currVal_121,currVal_122);
    const currVal_123:any = 'padded-container';
    _ck(_v,201,0,currVal_123);
    const currVal_135:any = '47%';
    _ck(_v,211,0,currVal_135);
    const currVal_149:any = _co._pallet;
    _ck(_v,216,0,currVal_149);
    const currVal_150:any = i1.ɵinlineInterpolate(1,'',i1.ɵunv(_v,219,0,_ck(_v,220,
        0,i1.ɵnov(_v,0),'pallet',_co._authService.getLanguage())),'');
    _ck(_v,219,0,currVal_150);
    const currVal_151:any = 'row';
    const currVal_152:any = 'column';
    _ck(_v,225,0,currVal_151,currVal_152);
    const currVal_153:any = '30px';
    const currVal_154:any = '14px';
    _ck(_v,226,0,currVal_153,currVal_154);
    const currVal_155:any = 'padded-container';
    _ck(_v,227,0,currVal_155);
    const currVal_167:any = _co.multiMode;
    _ck(_v,232,0,currVal_167);
    const currVal_168:any = 'column';
    _ck(_v,239,0,currVal_168);
    const currVal_169:any = '30px';
    const currVal_170:any = '14px';
    _ck(_v,240,0,currVal_169,currVal_170);
    const currVal_171:any = 'padded-container';
    _ck(_v,241,0,currVal_171);
    const currVal_172:boolean = !_co.multiMode;
    _ck(_v,244,0,currVal_172);
    const currVal_173:any = _co.multiMode;
    _ck(_v,247,0,currVal_173);
    const currVal_175:any = 'primary';
    _ck(_v,251,0,currVal_175);
    const currVal_176:any = 'bg-blue color-white';
    _ck(_v,253,0,currVal_176);
    const currVal_179:any = '12px';
    _ck(_v,264,0,currVal_179);
    const currVal_180:any = '';
    _ck(_v,265,0,currVal_180);
    const currVal_181:any = 'start';
    const currVal_182:any = 'center';
    _ck(_v,266,0,currVal_181,currVal_182);
    const currVal_183:any = 'table-control-buttons';
    _ck(_v,267,0,currVal_183);
    const currVal_185:any = 'primary';
    _ck(_v,271,0,currVal_185);
    const currVal_186:any = 'bg-blue color-white';
    _ck(_v,273,0,currVal_186);
    const currVal_189:any = 'primary';
    _ck(_v,279,0,currVal_189);
    const currVal_190:any = 'bg-blue color-white';
    _ck(_v,281,0,currVal_190);
    const currVal_193:any = 'primary';
    _ck(_v,287,0,currVal_193);
    const currVal_194:any = 'bg-blue color-white';
    _ck(_v,289,0,currVal_194);
    const currVal_197:any = _ck(_v,295,0,'/pda/shipping/prepareOrder');
    _ck(_v,294,0,currVal_197);
    const currVal_198:any = 'warn';
    _ck(_v,297,0,currVal_198);
    const currVal_199:any = 'bg-red color-white';
    _ck(_v,299,0,currVal_199);
  },(_ck,_v) => {
    var _co:i14.PrepareOrderItemsComponent = _v.component;
    const currVal_2:any = true;
    _ck(_v,7,0,currVal_2);
    const currVal_3:any = true;
    _ck(_v,11,0,currVal_3);
    const currVal_5:any = true;
    _ck(_v,16,0,currVal_5);
    const currVal_8:any = i1.ɵnov(_v,25).target;
    const currVal_9:any = i1.ɵnov(_v,25).href;
    _ck(_v,24,0,currVal_8,currVal_9);
    const currVal_11:any = i1.ɵunv(_v,27,0,_ck(_v,28,0,i1.ɵnov(_v,0),'shipping',_co._authService.getLanguage()));
    _ck(_v,27,0,currVal_11);
    const currVal_12:any = _co.order_number;
    const currVal_13:any = i1.ɵunv(_v,29,1,_ck(_v,30,0,i1.ɵnov(_v,0),'order_items',
        _co._authService.getLanguage()));
    _ck(_v,29,0,currVal_12,currVal_13);
    const currVal_14:any = true;
    _ck(_v,33,0,currVal_14);
    const currVal_16:any = i1.ɵunv(_v,37,0,_ck(_v,38,0,i1.ɵnov(_v,0),'prepare_order',
        _co._authService.getLanguage()));
    _ck(_v,37,0,currVal_16);
    const currVal_17:any = true;
    _ck(_v,41,0,currVal_17);
    const currVal_19:any = _co.preparedStatusText();
    _ck(_v,49,0,currVal_19);
    const currVal_20:any = (i1.ɵnov(_v,53).color == 'primary');
    const currVal_21:any = (i1.ɵnov(_v,53).color == 'accent');
    const currVal_22:any = (i1.ɵnov(_v,53).color == 'warn');
    const currVal_23:any = true;
    const currVal_24:any = i1.ɵnov(_v,53).value;
    const currVal_25:any = i1.ɵnov(_v,53).mode;
    _ck(_v,51,0,currVal_20,currVal_21,currVal_22,currVal_23,currVal_24,currVal_25);
    const currVal_32:any = i1.ɵunv(_v,62,0,_ck(_v,63,0,i1.ɵnov(_v,0),'notes_capital',
        _co._authService.getLanguage()));
    _ck(_v,62,0,currVal_32);
    const currVal_33:any = _co._notes;
    _ck(_v,66,0,currVal_33);
    const currVal_34:any = true;
    _ck(_v,70,0,currVal_34);
    const currVal_39:any = (null as any);
    const currVal_40:any = true;
    const currVal_41:any = i1.ɵnov(_v,80)._isErrorState();
    const currVal_42:any = i1.ɵnov(_v,80)._mdInputChild.focused;
    const currVal_43:any = i1.ɵnov(_v,80)._shouldForward('untouched');
    const currVal_44:any = i1.ɵnov(_v,80)._shouldForward('touched');
    const currVal_45:any = i1.ɵnov(_v,80)._shouldForward('pristine');
    const currVal_46:any = i1.ɵnov(_v,80)._shouldForward('dirty');
    const currVal_47:any = i1.ɵnov(_v,80)._shouldForward('valid');
    const currVal_48:any = i1.ɵnov(_v,80)._shouldForward('invalid');
    const currVal_49:any = i1.ɵnov(_v,80)._shouldForward('pending');
    _ck(_v,79,1,[currVal_39,currVal_40,currVal_41,currVal_42,currVal_43,currVal_44,
        currVal_45,currVal_46,currVal_47,currVal_48,currVal_49]);
    const currVal_51:any = i1.ɵnov(_v,94).ngClassUntouched;
    const currVal_52:any = i1.ɵnov(_v,94).ngClassTouched;
    const currVal_53:any = i1.ɵnov(_v,94).ngClassPristine;
    const currVal_54:any = i1.ɵnov(_v,94).ngClassDirty;
    const currVal_55:any = i1.ɵnov(_v,94).ngClassValid;
    const currVal_56:any = i1.ɵnov(_v,94).ngClassInvalid;
    const currVal_57:any = i1.ɵnov(_v,94).ngClassPending;
    const currVal_58:any = true;
    const currVal_59:any = i1.ɵnov(_v,95).id;
    const currVal_60:any = i1.ɵnov(_v,95).placeholder;
    const currVal_61:any = i1.ɵnov(_v,95).disabled;
    const currVal_62:any = i1.ɵnov(_v,95).required;
    const currVal_63:any = (i1.ɵnov(_v,95).ariaDescribedby || (null as any));
    _ck(_v,89,1,[currVal_51,currVal_52,currVal_53,currVal_54,currVal_55,currVal_56,
        currVal_57,currVal_58,currVal_59,currVal_60,currVal_61,currVal_62,currVal_63]);
    const currVal_71:any = true;
    const currVal_72:any = i1.ɵnov(_v,106).checked;
    const currVal_73:any = i1.ɵnov(_v,106).disabled;
    const currVal_74:any = (i1.ɵnov(_v,106).labelPosition == 'before');
    const currVal_75:any = i1.ɵnov(_v,110).ngClassUntouched;
    const currVal_76:any = i1.ɵnov(_v,110).ngClassTouched;
    const currVal_77:any = i1.ɵnov(_v,110).ngClassPristine;
    const currVal_78:any = i1.ɵnov(_v,110).ngClassDirty;
    const currVal_79:any = i1.ɵnov(_v,110).ngClassValid;
    const currVal_80:any = i1.ɵnov(_v,110).ngClassInvalid;
    const currVal_81:any = i1.ɵnov(_v,110).ngClassPending;
    _ck(_v,105,1,[currVal_71,currVal_72,currVal_73,currVal_74,currVal_75,currVal_76,
        currVal_77,currVal_78,currVal_79,currVal_80,currVal_81]);
    const currVal_89:any = (i1.ɵnov(_v,127).disabled || (null as any));
    _ck(_v,125,0,currVal_89);
    const currVal_92:any = i1.ɵunv(_v,130,0,_ck(_v,131,0,i1.ɵnov(_v,0),'verify',_co._authService.getLanguage()));
    _ck(_v,130,0,currVal_92);
    const currVal_93:any = true;
    _ck(_v,135,0,currVal_93);
    const currVal_99:any = (i1.ɵnov(_v,147).disabled || (null as any));
    _ck(_v,145,0,currVal_99);
    const currVal_102:any = i1.ɵunv(_v,150,0,_ck(_v,151,0,i1.ɵnov(_v,0),'prepare',
        _co._authService.getLanguage()));
    _ck(_v,150,0,currVal_102);
    const currVal_103:any = (i1.ɵnov(_v,155).disabled || (null as any));
    _ck(_v,153,0,currVal_103);
    const currVal_106:any = i1.ɵunv(_v,158,0,_ck(_v,159,0,i1.ɵnov(_v,0),'add_piece',
        _co._authService.getLanguage()));
    _ck(_v,158,0,currVal_106);
    const currVal_107:any = (i1.ɵnov(_v,163).disabled || (null as any));
    _ck(_v,161,0,currVal_107);
    const currVal_110:any = i1.ɵunv(_v,166,0,_ck(_v,167,0,i1.ɵnov(_v,0),'save_preparation_status',
        _co._authService.getLanguage()));
    _ck(_v,166,0,currVal_110);
    const currVal_111:any = (i1.ɵnov(_v,173).disabled || (null as any));
    _ck(_v,169,0,currVal_111);
    const currVal_115:any = i1.ɵunv(_v,176,0,_ck(_v,177,0,i1.ɵnov(_v,0),'back',_co._authService.getLanguage()));
    _ck(_v,176,0,currVal_115);
    const currVal_116:any = true;
    _ck(_v,183,0,currVal_116);
    const currVal_119:any = true;
    _ck(_v,194,0,currVal_119);
    const currVal_124:any = (null as any);
    const currVal_125:any = true;
    const currVal_126:any = i1.ɵnov(_v,204)._isErrorState();
    const currVal_127:any = i1.ɵnov(_v,204)._mdInputChild.focused;
    const currVal_128:any = i1.ɵnov(_v,204)._shouldForward('untouched');
    const currVal_129:any = i1.ɵnov(_v,204)._shouldForward('touched');
    const currVal_130:any = i1.ɵnov(_v,204)._shouldForward('pristine');
    const currVal_131:any = i1.ɵnov(_v,204)._shouldForward('dirty');
    const currVal_132:any = i1.ɵnov(_v,204)._shouldForward('valid');
    const currVal_133:any = i1.ɵnov(_v,204)._shouldForward('invalid');
    const currVal_134:any = i1.ɵnov(_v,204)._shouldForward('pending');
    _ck(_v,203,1,[currVal_124,currVal_125,currVal_126,currVal_127,currVal_128,currVal_129,
        currVal_130,currVal_131,currVal_132,currVal_133,currVal_134]);
    const currVal_136:any = i1.ɵnov(_v,218).ngClassUntouched;
    const currVal_137:any = i1.ɵnov(_v,218).ngClassTouched;
    const currVal_138:any = i1.ɵnov(_v,218).ngClassPristine;
    const currVal_139:any = i1.ɵnov(_v,218).ngClassDirty;
    const currVal_140:any = i1.ɵnov(_v,218).ngClassValid;
    const currVal_141:any = i1.ɵnov(_v,218).ngClassInvalid;
    const currVal_142:any = i1.ɵnov(_v,218).ngClassPending;
    const currVal_143:any = true;
    const currVal_144:any = i1.ɵnov(_v,219).id;
    const currVal_145:any = i1.ɵnov(_v,219).placeholder;
    const currVal_146:any = i1.ɵnov(_v,219).disabled;
    const currVal_147:any = i1.ɵnov(_v,219).required;
    const currVal_148:any = (i1.ɵnov(_v,219).ariaDescribedby || (null as any));
    _ck(_v,213,1,[currVal_136,currVal_137,currVal_138,currVal_139,currVal_140,currVal_141,
        currVal_142,currVal_143,currVal_144,currVal_145,currVal_146,currVal_147,currVal_148]);
    const currVal_156:any = true;
    const currVal_157:any = i1.ɵnov(_v,230).checked;
    const currVal_158:any = i1.ɵnov(_v,230).disabled;
    const currVal_159:any = (i1.ɵnov(_v,230).labelPosition == 'before');
    const currVal_160:any = i1.ɵnov(_v,234).ngClassUntouched;
    const currVal_161:any = i1.ɵnov(_v,234).ngClassTouched;
    const currVal_162:any = i1.ɵnov(_v,234).ngClassPristine;
    const currVal_163:any = i1.ɵnov(_v,234).ngClassDirty;
    const currVal_164:any = i1.ɵnov(_v,234).ngClassValid;
    const currVal_165:any = i1.ɵnov(_v,234).ngClassInvalid;
    const currVal_166:any = i1.ɵnov(_v,234).ngClassPending;
    _ck(_v,229,1,[currVal_156,currVal_157,currVal_158,currVal_159,currVal_160,currVal_161,
        currVal_162,currVal_163,currVal_164,currVal_165,currVal_166]);
    const currVal_174:any = (i1.ɵnov(_v,251).disabled || (null as any));
    _ck(_v,249,0,currVal_174);
    const currVal_177:any = i1.ɵunv(_v,254,0,_ck(_v,255,0,i1.ɵnov(_v,0),'verify',_co._authService.getLanguage()));
    _ck(_v,254,0,currVal_177);
    const currVal_178:any = true;
    _ck(_v,259,0,currVal_178);
    const currVal_184:any = (i1.ɵnov(_v,271).disabled || (null as any));
    _ck(_v,269,0,currVal_184);
    const currVal_187:any = i1.ɵunv(_v,274,0,_ck(_v,275,0,i1.ɵnov(_v,0),'prepare',
        _co._authService.getLanguage()));
    _ck(_v,274,0,currVal_187);
    const currVal_188:any = (i1.ɵnov(_v,279).disabled || (null as any));
    _ck(_v,277,0,currVal_188);
    const currVal_191:any = i1.ɵunv(_v,282,0,_ck(_v,283,0,i1.ɵnov(_v,0),'add_piece',
        _co._authService.getLanguage()));
    _ck(_v,282,0,currVal_191);
    const currVal_192:any = (i1.ɵnov(_v,287).disabled || (null as any));
    _ck(_v,285,0,currVal_192);
    const currVal_195:any = i1.ɵunv(_v,290,0,_ck(_v,291,0,i1.ɵnov(_v,0),'save_preparation_status',
        _co._authService.getLanguage()));
    _ck(_v,290,0,currVal_195);
    const currVal_196:any = (i1.ɵnov(_v,297).disabled || (null as any));
    _ck(_v,293,0,currVal_196);
    const currVal_200:any = i1.ɵunv(_v,300,0,_ck(_v,301,0,i1.ɵnov(_v,0),'back',_co._authService.getLanguage()));
    _ck(_v,300,0,currVal_200);
  });
}
export function View_PrepareOrderItemsComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),4,'app-prepare-order-items',
      ([] as any[]),(null as any),(null as any),(null as any),View_PrepareOrderItemsComponent_0,
      RenderType_PrepareOrderItemsComponent)),i1.ɵprd(512,(null as any),i16.PalletService,
      i16.PalletService,[i17.Http,i18.Configuration,i19.AuthenticationService]),i1.ɵprd(512,
      (null as any),i20.ProductService,i20.ProductService,[i17.Http,i18.Configuration,
          i19.AuthenticationService]),i1.ɵprd(512,(null as any),i21.PrintingService,
      i21.PrintingService,[i17.Http,i18.Configuration,i19.AuthenticationService]),
      i1.ɵdid(114688,(null as any),0,i14.PrepareOrderItemsComponent,[i22.SalesService,
          i23.PoService,i24.TdDialogService,i16.PalletService,i13.Router,i13.ActivatedRoute,
          i19.AuthenticationService,i20.ProductService,i21.PrintingService,i25.InventoryService],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,4,0);
  },(null as any));
}
export const PrepareOrderItemsComponentNgFactory:i1.ComponentFactory<i14.PrepareOrderItemsComponent> = i1.ɵccf('app-prepare-order-items',
    i14.PrepareOrderItemsComponent,View_PrepareOrderItemsComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/$$_gendir/app/agatextscreens/pda/shipping/prepare-order-items/prepare-order-items.component.ngfactory.ts